import React from "react";

export const Fasttrade = () => {
  return <div>FastTrade</div>;
};
